import { Component, Input, Output, EventEmitter, Optional, Self, OnInit } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';

export interface Option {
  value: string;
  label: string;
}

@Component({
  selector: 'app-select',
  standalone: true,
  imports: [],
  templateUrl: './select.html',
})
export class SelectComponent implements ControlValueAccessor, OnInit {

  @Input() options: Option[] = [];
  @Input() placeholder: string = 'Select an option';
  @Input() className: string = '';
  @Input() defaultValue: string = '';

  // Keep @Input() value so [value]="..." still works in other templates
  @Input() set value(val: string) {
    this._value = val ?? '';
  }
  get value(): string {
    return this._value;
  }
  private _value = '';

  // Keep (valueChange) output so old templates don't break
  @Output() valueChange = new EventEmitter<string>();

  private onChange: (val: string) => void = () => {};
  onTouched: () => void = () => {};

  constructor(@Optional() @Self() private ngControl: NgControl) {
    if (ngControl) {
      ngControl.valueAccessor = this;
    }
  }

  ngOnInit() {
    if (!this._value && this.defaultValue) {
      this._value = this.defaultValue;
    }
  }

  // ControlValueAccessor
  writeValue(val: string): void {
    this._value = val ?? '';
  }

  registerOnChange(fn: (val: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(_: boolean): void {}

  onSelectChange(event: Event) {
    const val = (event.target as HTMLSelectElement).value;
    this._value = val;
    this.onChange(val);        // for ngModel / reactive forms
    this.valueChange.emit(val); // for old (valueChange)="..." bindings
    this.onTouched();
  }
}